var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvisibleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.415659 1.02281C0.817212 0.786378 1.3344 0.920233 1.57084 1.32179C2.99409 3.73899 5.77394 5.40614 9.00001 5.40614C12.2261 5.40614 15.0059 3.73899 16.4292 1.32179C16.6656 0.920233 17.1828 0.786378 17.5844 1.02281C17.9859 1.25925 18.1198 1.77644 17.8833 2.17799C16.1485 5.12437 12.8073 7.09364 9.00001 7.09364C5.19274 7.09364 1.85151 5.12437 0.116685 2.17799C-0.11975 1.77644 0.0141049 1.25925 0.415659 1.02281Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.58266 8.20878C0.225691 7.90925 0.179129 7.37705 0.478662 7.02008L2.524 4.58254C2.82353 4.22557 3.35573 4.17901 3.7127 4.47854C4.06967 4.77807 4.11623 5.31027 3.8167 5.66724L1.77136 8.10478C1.47183 8.46175 0.939629 8.50831 0.58266 8.20878Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.89893 10.0328C5.46104 9.87346 5.23527 9.38928 5.39465 8.9514L6.48295 5.96131C6.64233 5.52342 7.1265 5.29765 7.56439 5.45703C8.00228 5.6164 8.22806 6.10058 8.06868 6.53847L6.98038 9.52855C6.821 9.96644 6.33682 10.1922 5.89893 10.0328Z",
    fill: "#808080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6269 10.0328C12.189 10.1922 11.7048 9.96644 11.5454 9.52855L10.4571 6.53847C10.2978 6.10058 10.5235 5.6164 10.9614 5.45702C11.3993 5.29765 11.8835 5.52342 12.0429 5.96131L13.1312 8.9514C13.2906 9.38928 13.0648 9.87346 12.6269 10.0328Z",
    fill: "#808080"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2127 8.20878C16.8557 8.50831 16.3235 8.46175 16.024 8.10478L13.9787 5.66724C13.6791 5.31027 13.7257 4.77807 14.0827 4.47854C14.4396 4.17901 14.9718 4.22557 15.2714 4.58254L17.3167 7.02008C17.6162 7.37705 17.5697 7.90925 17.2127 8.20878Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisibleIcon);
export default __webpack_public_path__ + "static/media/invisible-icon.7d11926409ab297a3ae5da7e7032b4c3.svg";
export { ForwardRef as ReactComponent };